import React, { useEffect } from "react";

const Modal = ({ isOpen, toggle, title, children, fullWidth }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"; // Prevent scrolling when modal is open
    } else {
      document.body.style.overflow = ""; // Reset overflow to its default value
    }
    return () => {
      document.body.style.overflow = ""; // Clean up on unmount
    };
  }, [isOpen]);

  return (
    <>
      {isOpen ? (
        <div
          className="fixed top-0 bottom-0 right-0 left-0 z-50 bg-[rgba(0,0,0,0.6)]  flex justify-center items-center"
        >
          <div
            className={`relative  flex flex-col border-2 border-black dark:border-white  bg-[#F7F6F9] dark:bg-[#000] rounded-2xl shadow-lg 
            max-h-[80%] xs:max-h-[90%]
            2xl:max-w-[60%] 2xl:min-w-[60%]
            xl:max-w-[60%] xl:min-w-[60%]
            lg:max-w-[60%] lg:min-w-[60%]
            md:max-w-[70%] md:min-w-[70%]
            sm:max-w-[70%] sm:min-w-[70%]
            xs:max-w-[95%] xs:min-w-[95%]`}
          >
            {/* Modal Header */}
            <div className="bg-[#C5A6F2D4] min-h-[60px] max-h-[60px] rounded-t-xl flex justify-between px-3 items-center">
              <p className="dark:text-white font-InterBold text-[20px] truncate xs:w-[140px]">{title}</p>
              {toggle && (
                <div
                  className="w-[70px] h-[37px] flex items-center justify-center rounded-[10px] bg-[#666567] cursor-pointer"
                  onClick={toggle}
                >
                 <p className="text-white font-Inter text-[11px] font-[500px]">Close</p>
                </div>
              )}
            </div>

            {/* Modal Content */}
            <div className="overflow-y-auto p-5">{children}</div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Modal;
